import apiClient from './AuthService';

export interface LandscapeAndTexturesChallenge {
  landscape_and_textures_challenge_id?: string;
  project_id: string;
  user_id?: string;
  member_id: string;
  room: string;
  activity1?: string | null;
  activity2?: string | null;
  activity3?: string | null;
  image_activity1?: string | null;
  image_activity2?: string | null;
  image_activity3?: string | null;
  answer_activity1?: string | null;
  answer_activity2?: string | null;
  answer_activity3?: string | null;
  texture_activity1?: string | null;
  texture_activity2?: string | null;
  texture_activity3?: string | null;
  coords_activity1?: string | null;
  coords_activity2?: string | null;
  coords_activity3?: string | null;
  texture_answer_activity1?: string | null;
  texture_answer_activity2?: string | null;
  texture_answer_activity3?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface LandscapeAndTexturesChallengeResponse {
  landscape_and_textures_challenge_id: string;
  message: string;
}

export interface LandscapeAndTexturesChallengeData {
  data: LandscapeAndTexturesChallenge | LandscapeAndTexturesChallenge[];
}

export interface CreateLandscapeAndTexturesChallengeRequest {
  project_id: string;
  member_id: string;
  room: string;
  activity1?: string | null;
  activity2?: string | null;
  activity3?: string | null;
  image_activity1?: string | null;
  image_activity2?: string | null;
  image_activity3?: string | null;
  answer_activity1?: string | null;
  answer_activity2?: string | null;
  answer_activity3?: string | null;
  texture_activity1?: string | null;
  texture_activity2?: string | null;
  texture_activity3?: string | null;
  coords_activity1?: string | null;
  coords_activity2?: string | null;
  coords_activity3?: string | null;
  texture_answer_activity1?: string | null;
  texture_answer_activity2?: string | null;
  texture_answer_activity3?: string | null;
}

export interface UpdateLandscapeAndTexturesChallengeRequest {
  activity1?: string | null;
  activity2?: string | null;
  activity3?: string | null;
  image_activity1?: string | null;
  image_activity2?: string | null;
  image_activity3?: string | null;
  answer_activity1?: string | null;
  answer_activity2?: string | null;
  answer_activity3?: string | null;
  texture_activity1?: string | null;
  texture_activity2?: string | null;
  texture_activity3?: string | null;
  coords_activity1?: string | null;
  coords_activity2?: string | null;
  coords_activity3?: string | null;
  texture_answer_activity1?: string | null;
  texture_answer_activity2?: string | null;
  texture_answer_activity3?: string | null;
}

export const createLandscapeAndTexturesChallenge = async (
  request: CreateLandscapeAndTexturesChallengeRequest
): Promise<LandscapeAndTexturesChallengeResponse> => {
  try {
    console.log('📤 Creating LandscapeAndTextures challenge:', request);

    const response = await apiClient.post<LandscapeAndTexturesChallengeResponse>(
      '/quiz/landscape-and-textures-challenge',
      request
    );

    console.log('✅ LandscapeAndTextures challenge created:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('❌ LandscapeAndTextures API Error:', {
      status: error.response?.status,
      data: error.response?.data,
      fullError: error
    });

    if (error.response?.data?.error && typeof error.response.data.error === 'string') {
      throw new Error(error.response.data.error);
    } else if (error.response?.data?.message && typeof error.response.data.message === 'string') {
      throw new Error(error.response.data.message);
    } else if (error.response?.data && typeof error.response.data === 'string') {
      throw new Error(error.response.data);
    }

    throw new Error('Error al crear el challenge de paisajes y texturas. Por favor, intenta de nuevo.');
  }
};

export const updateLandscapeAndTexturesChallenge = async (
  landscapeAndTexturesChallengeId: string,
  request: UpdateLandscapeAndTexturesChallengeRequest
): Promise<LandscapeAndTexturesChallengeResponse> => {
  try {
    console.log('📤 Updating LandscapeAndTextures challenge:', landscapeAndTexturesChallengeId, request);

    const response = await apiClient.put<LandscapeAndTexturesChallengeResponse>(
      `/quiz/landscape-and-textures-challenge/${landscapeAndTexturesChallengeId}`,
      request
    );

    console.log('✅ LandscapeAndTextures challenge updated:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('❌ LandscapeAndTextures Update API Error:', {
      status: error.response?.status,
      data: error.response?.data,
      fullError: error
    });

    if (error.response?.data?.error && typeof error.response.data.error === 'string') {
      throw new Error(error.response.data.error);
    } else if (error.response?.data?.message && typeof error.response.data.message === 'string') {
      throw new Error(error.response.data.message);
    } else if (error.response?.data && typeof error.response.data === 'string') {
      throw new Error(error.response.data);
    }

    throw new Error('Error al actualizar el challenge de paisajes y texturas. Por favor, intenta de nuevo.');
  }
};

export const getLandscapeAndTexturesChallenge = async (
  landscapeAndTexturesChallengeId: string
): Promise<LandscapeAndTexturesChallenge> => {
  try {
    console.log('📡 Fetching LandscapeAndTextures challenge:', landscapeAndTexturesChallengeId);

    const response = await apiClient.get<LandscapeAndTexturesChallengeData>(
      `/quiz/landscape-and-textures-challenge/${landscapeAndTexturesChallengeId}`
    );

    console.log('📡 Response received:', response.data);
    return response.data.data as LandscapeAndTexturesChallenge;
  } catch (error: any) {
    console.error('❌ getLandscapeAndTexturesChallenge error:', {
      status: error.response?.status,
      data: error.response?.data,
      fullError: error
    });

    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    } else if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};

export const getProjectLandscapeAndTexturesChallenges = async (
  projectId: string
): Promise<LandscapeAndTexturesChallenge[]> => {
  try {
    console.log('📡 Fetching LandscapeAndTextures challenges for project:', projectId);

    const response = await apiClient.get<LandscapeAndTexturesChallengeData>(
      `/quiz/project/${projectId}/landscape-and-textures-challenges`
    );

    console.log('📡 Response received:', response.data);

    // Handle both wrapped and direct response formats
    const data = response.data.data || response.data;

    // If data is not an array, wrap it
    if (!Array.isArray(data)) {
      return data ? [data] : [];
    }

    return data as LandscapeAndTexturesChallenge[];
  } catch (error: any) {
    console.error('❌ getProjectLandscapeAndTexturesChallenges error:', {
      status: error.response?.status,
      data: error.response?.data,
      fullError: error
    });

    // Return empty array for 404 (no data found)
    if (error.response?.status === 404) {
      console.log('📡 No challenges found for project (404), returning empty array');
      return [];
    }

    // For other errors, log and throw
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    } else if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};
